module.exports = __webpack_public_path__ + "images/new_capture/capture-intro@1x-2462bc7a1cd5e255ca53a4c1da8cdaee.png";